import { RuleConditionApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { uid } from '../../../../lib/helpers/uid';
import { Comparisons } from '../../rules/Comparisons';
import { getItemValuesForCondition } from './getItemValuesForCondition';

export function generateConditionsForInlineRule(
  item: SmartSendItemApiModel,
  conditions: string[]
): RuleConditionApiModel[] {
  return conditions.map((condition) => ({
    Comparison: Comparisons.IsOneOf,
    Field: condition,
    Values: getItemValuesForCondition(item, condition),
    Id: uid()
  }));
}
